// 热搜词管理
import http from "@/jslibs/axios/http";

// 热搜词列表
export const list = (data) => http.get("/v1/cms/HotWord", data);

// 热搜词新增
export const add = (data) => http.post("/v1/cms/HotWord", data);

// 热搜词编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/HotWord/${uuid}`, data);

// 热搜词删除
export const del = ({ uuid }) => http.delete(`/v1/cms/HotWord/${uuid}`);

// 热搜词详情
export const detail = ({ uuid }) => http.get(`/v1/cms/HotWord/${uuid}`);
